import { render, staticRenderFns } from "./CardViewer.vue?vue&type=template&id=66192d95&scoped=true"
import script from "./CardViewer.vue?vue&type=script&lang=js"
export * from "./CardViewer.vue?vue&type=script&lang=js"
import style0 from "./CardViewer.vue?vue&type=style&index=0&id=66192d95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66192d95",
  null
  
)

export default component.exports